/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
import {getIamUserAccess, getUserByToken, login} from '../core/_requests'
import {getAppLogoUrl, groupMenusByLevelAndOrder} from '../../../../_metronic/helpers'
import {useAuth} from '../core/Auth'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Email is required'),
  password: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Password is required'),
})

const initialValues = {
  email: '',
  password: '',
}

export function Login() {
  const [loading, setLoading] = useState(false)
  const {token, saveAuth, setCurrentUser, saveMenuAccess} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      try {
        const {data: auth} = await login(values.email, values.password)
        const {data: iamAccess} = await getIamUserAccess()
        const menuAccess = groupMenusByLevelAndOrder(iamAccess?.response?.data?.menu_access)
        saveMenuAccess(menuAccess)
        saveAuth(auth.response?.data)
        const {data: user} = await getUserByToken(token || '')
        setCurrentUser(user?.response?.data)
      } catch (error) {
        console.error(error)
        saveAuth(undefined)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  return (
    <form
      className='auth-login'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      <div className='auth-login-head'>
        <img alt='Logo' src={getAppLogoUrl()} className='auth-login-logo' />
        <h2 className='auth-login-title'>Login</h2>
      </div>

      {formik.status && <div className='auth-login-status'>{formik.status}</div>}

      <div className='auth-login-field'>
        <label className='form-label' htmlFor='auth-email'>
          Email
        </label>
        <input
          id='auth-email'
          type='email'
          autoComplete='off'
          placeholder='you@example.com'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control',
            formik.touched.email && formik.errors.email && 'is-invalid'
          )}
        />
        {formik.touched.email && formik.errors.email && (
          <span role='alert' className='auth-login-error'>
            {formik.errors.email}
          </span>
        )}
      </div>

      <div className='auth-login-field'>
        <label className='form-label' htmlFor='auth-password'>
          Password
        </label>
        <input
          id='auth-password'
          type='password'
          autoComplete='off'
          placeholder='••••••••'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control',
            formik.touched.password && formik.errors.password && 'is-invalid'
          )}
        />
        {formik.touched.password && formik.errors.password && (
          <span role='alert' className='auth-login-error'>
            {formik.errors.password}
          </span>
        )}
      </div>

      <div className='auth-login-forgot'>
        <Link to='/auth/forgot-password' className='auth-login-forgot-link'>
          Forgot Password ?
        </Link>
      </div>

      <button
        type='submit'
        id='kt_sign_in_submit'
        className='btn btn-primary w-100'
        disabled={formik.isSubmitting || !formik.isValid}
      >
        {!loading ? 'Login' : 'Please wait...'}
      </button>
    </form>
  )
}
